import http from "@/http-common";

/**
 * Service quản lý khoản thu gốc (Managing Principal Revenue)
 * Base URL: /receipt/v1/tuition/managing-principal-revenues
 * Lưu ý: idSchool KHÔNG cần truyền – BE tự xác định qua JWT token.
 */
class ManagingPrincipalRevenueService {
  /**
   * Tìm kiếm danh sách khoản thu gốc có phân trang
   * @param {Object} params - { keyword, category, page, size }
   */
  search(params) {
    return http.get("receipt/v1/tuition/managing-principal-revenues", { params });
  }

  /**
   * Lấy chi tiết một khoản thu gốc theo ID
   * @param {string} id - UUID
   */
  findById(id) {
    return http.get(`receipt/v1/tuition/managing-principal-revenues/${id}`);
  }

  /**
   * Tạo mới khoản thu gốc
   * @param {Object} data - PrincipalRevenueCreateRequest (không cần idSchool)
   */
  create(data) {
    return http.post("receipt/v1/tuition/managing-principal-revenues", data);
  }

  /**
   * Cập nhật khoản thu gốc
   * @param {string} id - UUID
   * @param {Object} data - PrincipalRevenueUpdateRequest (không cần idSchool)
   */
  update(id, data) {
    return http.put(`receipt/v1/tuition/managing-principal-revenues/${id}`, data);
  }

  /**
   * Xóa mềm khoản thu gốc
   * @param {string} id - UUID
   */
  remove(id) {
    return http.delete(`receipt/v1/tuition/managing-principal-revenues/${id}`);
  }

  /**
   * Lấy danh sách khoản thu đang hoạt động của 1 trường
   */
  findActivePrincipalRevenues() {
    return http.get("receipt/v1/tuition/managing-principal-revenues/active");
  }
}

export default new ManagingPrincipalRevenueService();
